import React, { useEffect, useState } from 'react'
import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Input,
    Flex,
    FormLabel,
    Heading, TableContainer, useToast
} from '@chakra-ui/react'
import { AiOutlinePlusCircle } from "react-icons/ai";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NewOrg = () => {
    const [data, setData] = useState([]);
    const [orgName, setOrgName] = useState("");
    const navigate = useNavigate()
    const user = useSelector((state) => state.user.userData);
    const orgId = useSelector((state) => state.user.orgId);
    const [shouldFetchData, setShouldFetchData] = useState(true);
    const toast = useToast();

    if (user && user.userDetailsDto && user.userDetailsDto.role !== "OWNER") {
        navigate(`/accessdenied?orgId=${orgId}`);
    }

    const getOrgDetails = () => {
        axios.get("http://18.132.190.48:8080/api/v1/getOrgs")
            .then((r) => {
                setData(r.data)
            })
            .catch((err) => console.log(err))
    }



    useEffect(() => {
        if (shouldFetchData) {
            getOrgDetails();
            setShouldFetchData(false);
        }
    }, [shouldFetchData]);

    const addOrgDetails = () => {
        axios.post(`http://18.132.190.48:8080/api/v1/add/org/${orgName}`)
            .then(() => {
                toast({
                    position: 'top',
                    title: 'Team Created Successfully.',
                    status: 'success',
                    duration: 4000,
                    isClosable: true,
                })
                setShouldFetchData(true);
                setOrgName("");
            })
            .catch(error => {
                console.log(error);
            });
    }


    return (
        <>
            <Flex m="auto" my={"40px"} w="700px" justify="center" align="center">
                <FormLabel mt={1}>Add Organization:</FormLabel>
                <Input onChange={(e) => setOrgName(e.target.value)} value={orgName} type="text" placeholder='Add Organization' w="350px" p={5} border="1px solid black" />
                <Box ml={3} >
                    <AiOutlinePlusCircle size="30px" onClick={addOrgDetails} />
                </Box>
            </Flex>
            <Box>
                <Heading textAlign="center" size="md">Existing Organizations</Heading>
                <TableContainer w="50%" m="auto" mt={5} bgColor="white">
                    <Table >
                        <Thead>
                            <Tr>
                                <Th bgColor="lavender" border="1px solid black" color="black" textAlign={"center"} py={4}>Organization Name</Th>
                                <Th bgColor="lavender" border="1px solid black" color="black" textAlign={"center"} py={4}>Organization ID</Th>
                            </Tr>
                        </Thead>
                        {
                            data?.map((e) => (
                                <Tbody key={e.orgId}>
                                    <Tr>
                                        <Td border="1px solid black" textAlign={"center"} py={2}>{e.orgName}</Td>
                                        <Td border="1px solid black" textAlign={"center"} py={2}>{e.orgId}</Td>
                                    </Tr>
                                </Tbody>
                            ))
                        }
                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}

export default NewOrg
